export default function NotFound() {
  return (
    <div className="h-32 flex justify-center items-center text-center text-gray-700 font-bold">
      <span>Belum ada data</span>
    </div>
  );
}
